module.exports = "<div ng-if=\"$ctrl.ngModel.non_field_errors\" class=\"alert alert-danger\">\n    <ul class=\"list-unstyled\">\n        <li ng-repeat=\"message in $ctrl.ngModel.non_field_errors\" ng-bind=\"message\"></li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/error.messages.html
// module id = 515
// module chunks = 0